import { Close } from "@mui/icons-material";
import { Divider, Grid2, IconButton, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { IOrder } from "sierra";
import { getOrderStatus } from "../../../../utils/getOrderStatus";
import Container from "../../../../components/Container";
import { useApp } from "../../../../contexts/AppContext";

export default function OrderInformation() {
    const { lang } = useApp()
    const location = useLocation()
    const navigate = useNavigate()
    const {translate} = useApp()

    const order: Required<IOrder> = location.state?.order;

    if (!order) {
        navigate(-1)
        return null;
    }

    return (
        <Grid2 container flexDirection={'column'} gap={2} padding={2}>
            <Grid2 container justifyContent={'space-between'} alignItems={'center'}>
                <Grid2>
                    <Typography variant='h5' fontWeight={'bold'}>
                        {translate("Order Information")}
                    </Typography>
                </Grid2>
                <Grid2>
                    <IconButton onClick={() => navigate('/system/orders/manage?order_id=' + order.order_id)}>
                        <Close />
                    </IconButton>
                </Grid2>
            </Grid2>
            <Container size={'auto'} container flexDirection={'column'} gap={2} padding={2}>

                <Grid2 container justifyContent={'space-between'}>
                    <Grid2>
                        <Typography variant='body1'>
                            {translate("Order ID")}:
                        </Typography>
                    </Grid2>
                    <Grid2>
                        <Typography variant='body1'>
                            {order.order_id}
                        </Typography>
                    </Grid2>
                </Grid2>

                <Divider flexItem />

                <Grid2 container justifyContent={'space-between'}>
                    <Grid2>
                        <Typography variant='body1'>
                            {translate("Customer Name")}
                        </Typography>
                    </Grid2>
                    <Grid2>
                        <Typography variant='body1'>
                            {order.customer?.name}
                        </Typography>
                    </Grid2>
                </Grid2>

                <Divider flexItem />

                <Grid2 container justifyContent={'space-between'}>
                    <Grid2>
                        <Typography variant='body1'>
                            {translate("Service")}
                        </Typography>
                    </Grid2>
                    <Grid2>
                        <Typography variant='body1'>
                            {order.service?.service_name[lang]}
                        </Typography>
                    </Grid2>
                </Grid2>


                <Divider flexItem />

                <Grid2 container justifyContent={'space-between'}>
                    <Grid2>
                        <Typography variant='body1'>
                            {translate("Total Person")}:
                        </Typography>
                    </Grid2>
                    <Grid2>
                        <Typography variant='body1'>
                            {order.order_amount_mult}
                        </Typography>
                    </Grid2>
                </Grid2>


                <Divider flexItem />

                <Grid2 container justifyContent={'space-between'}>
                    <Grid2>
                        <Typography variant='body1'>
                            {translate("Order Date")}:
                        </Typography>
                    </Grid2>
                    <Grid2>
                        <Typography variant='body1'>
                            {new Date(order.creation_timestamp).toLocaleString(lang === 'ar' ? 'ar-SD' : undefined)}
                        </Typography>
                    </Grid2>
                </Grid2>

                <Divider flexItem />

                <Grid2 container justifyContent={'space-between'}>
                    <Grid2>
                        <Typography variant='body1'>
                            {translate("Total Amount")}:
                        </Typography>
                    </Grid2>
                    <Grid2>
                        <Typography variant='body1'>
                            {(order.order_amount_total / 100).toFixed(2)} {translate("SAR")}
                        </Typography>
                    </Grid2>
                </Grid2>


                <Divider flexItem />

                <Grid2 container justifyContent={'space-between'}>
                    <Grid2>
                        <Typography variant='body1'>
                            {translate("Order Status")}:
                        </Typography>
                    </Grid2>
                    <Grid2>
                        <Typography variant='body1'>
                            {translate(getOrderStatus(order))}
                        </Typography>
                    </Grid2>
                </Grid2>

                <Divider flexItem />

                <Grid2 container justifyContent={'space-between'}>
                    <Grid2>
                        <Typography variant='body1'>
                            {translate("Paid")}:
                        </Typography>
                    </Grid2>
                    <Grid2>
                        <Typography variant='body1'>
                            {order.order_paid ? translate('Yes') : translate('No')}
                        </Typography>
                    </Grid2>
                </Grid2>
            </Container>
        </Grid2 >
    )
}